"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loginMutationOptions = exports.loginMutation = void 0;
const client_1 = require("@apollo/client");
const meUser_1 = require("../fragments/meUser");
const me_1 = require("../queries/me");
exports.loginMutation = client_1.gql `
  mutation Login($input: LoginInput!) {
    login(input: $input) {
      __typename
      errors {
        path
        message
      }
      user {
        ...meUser
      }
    }
  }

  ${meUser_1.meUserFragment}
`;
exports.loginMutationOptions = (variables) => ({
    variables,
    update: (cache, { data }) => {
        if (!data || !data.login.user) {
            return;
        }
        cache.writeQuery({
            query: me_1.meQuery,
            data: {
                __typename: "Query",
                me: {
                    __typename: "UserResponse",
                    user: Object.assign({}, data.login.user),
                },
            },
        });
    },
});
//# sourceMappingURL=Login.js.map